import React, { useEffect, useRef, useState } from "react";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Box from "@mui/material/Box";
import TabPanel from "@mui/lab/TabPanel";
import { TabContext } from "@mui/lab";
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  IconButton,
  TextField,
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import "./Section.css";
import SuccessAlert from "../components/success-alert/SuccessAlert";
import ErrorAlert from "../components/error-alert/ErrorAlert";
import useLanguages from "../hooks/useLanguages";
import { API, SERVER_DOMAIN } from "../assets/staticData";
import EmailIcon from "@mui/icons-material/Email";
import PhoneInTalkIcon from "@mui/icons-material/PhoneInTalk";
import LocationOnIcon from "@mui/icons-material/LocationOn";
import { COLORS } from "../assets/colors";
import { AddCircleOutlineRounded } from "@mui/icons-material";
import { GridDeleteIcon } from "@mui/x-data-grid";
import { toast } from "react-toastify";
import EditIcon from "@mui/icons-material/Edit";
import EditFAQ from "../components/editors/EditFAQ";
import { CACHE_KEY } from "../constant/cache-key";
import ClearCacheButton from "../components/ClearCacheButton/ClearCacheButton";

export default function ContactUs({ user }) {
  const langs = useLanguages();

  const [value, setValue] = useState("0");
  const [value2, setValue2] = useState("one");
  const [data, setData] = useState([]);
  const [errors, setErrors] = useState([]);
  const [success, setSuccess] = useState(false);
  const [fail, setFail] = useState(false);
  const [loading, setLoading] = useState(true);
  const [success2, setSuccess2] = useState(false);
  const [fail2, setFail2] = useState(false);
  const [openAdd, setOpenAdd] = useState([]);
  const [faqs, setFaqs] = useState([]);
  const [faq, setFaq] = useState([]);
  const [editItem, setEditItem] = useState({});
  const [refresh, setRefresh] = useState(false);

  let userToken = localStorage.getItem("userToken");

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  const handleChange2 = (event, newValue) => {
    setValue2(newValue);
  };

  let tabStyle = { textTransform: "capitalize", fontWeight: "500" };

  // Get Data from backend
  useEffect(() => {
    let docs = langs.map((item) => ({
      email: "",
      phone: "",
      address: "",
      faqs: [],
      language: item.attributes.language,
    }));
    setData(docs);

    let errorDocs = [];
    langs.map(() => {
      errorDocs.push({ error: false });
    });
    setErrors(errorDocs);

    let openDocs = [];
    langs.map(() => {
      openDocs.push({ open: false });
    });
    setOpenAdd(openDocs);

    let faqDocs = [];
    langs.map(() => {
      faqDocs.push({ q: "", a: "" });
    });
    setFaq(faqDocs);

    async function getData() {
      await fetch(`${API}/contact-us`, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${userToken}`,
        },
      }).then(async (res) => {
        const response = await res.json();
        const apiData = response.data?.attributes?.contactData || [];

        setData((prevData) => {
          return prevData.map((localItem) => {
            const apiItem = apiData.find((apiItem) => apiItem.language === localItem.language);

            if (apiItem) {
              return {
                ...localItem,
                email: apiItem.email || localItem.email,
                phone: apiItem.phone || localItem.phone,
                address: apiItem.address || localItem.address,
                faqs: apiItem.faqs || localItem.faqs,
              };
            } else {
              return localItem;
            }
          });
        });
        setLoading(false);
      });

      fetch(`${API}/faqs`, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${userToken}`,
        },
      }).then(async (res) => {
        const response = await res.json();
        setFaqs(response.data?.attributes?.faqs);
      });
    }

    getData();
  }, [langs]);

  const submitData = (item, index) => {
    fetch(`${API}/contact-us`, {
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${userToken}`,
      },
      body: JSON.stringify({
        data: { contactData: data },
      }),
    }).then(async (res) => {
      if (res.ok) {
        setSuccess(true);
      } else {
        setFail(true);
      }
    });
  };

  const uploadFAQ = async (index) => {
    if (faq[index]?.q !== "" && faq[index]?.a !== "") {
      let fullData = data;
      fullData[index]?.faqs.push(faq[index]);

      await fetch(`${API}/contact-us`, {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${userToken}`,
        },
        body: JSON.stringify({
          data: { contactData: fullData },
        }),
      }).then(async (res) => {
        setData(fullData);
        setOpenAdd([
          ...openAdd.map((item, idx) => {
            if (idx === index) {
              return { ...item, open: false };
            } else {
              return item;
            }
          }),
        ]);
        setFaq([
          ...faq.map((item, idx) => {
            if (idx === index) {
              return { ...item, a: "", q: "" };
            } else {
              return item;
            }
          }),
        ]);
        if (res.ok) {
          setSuccess2(true);
        } else {
          setFail2(true);
        }
      });
    } else {
      toast("Please fill the required fields", {
        position: "top-center",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
        type: "error",
      });
    }
  };

  const deleteItem = async (index, indexx) => {
    const newData = data.map((item, i) => {
      if (i === index && item.faqs) {
        return {
          ...item,
          faqs: item.faqs.filter((faq, j) => j !== indexx),
        };
      }
      return item;
    });

    await fetch(`${API}/contact-us`, {
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${userToken}`,
      },
      body: JSON.stringify({
        data: { contactData: newData },
      }),
    }).then(async (res) => {
      setData(newData);
      if (res.ok) {
        setSuccess2(true);
      } else {
        setFail2(true);
      }
    });
  };

  return (
    <>
      <TabContext value={value}>
        <ClearCacheButton keys={[
          CACHE_KEY.contactUs
        ]} />

        <Box sx={{ width: "100%" }}>
          <h3 style={{ textTransform: "capitalize" }}>Contact Us Settings</h3>
          <Tabs
            value={value}
            onChange={handleChange}
            textColor="secondary"
            indicatorColor="secondary"
            aria-label="secondary tabs">
            {langs?.map((item, index) => {
              return (
                <Tab
                  key={index}
                  sx={tabStyle}
                  value={index.toString()}
                  label={item.attributes.language}
                  icon={
                    <img
                      src={SERVER_DOMAIN + item.attributes.icon.data.attributes.url}
                      style={{ width: 25, aspectRatio: 1, borderRadius: 20 }}
                    />
                  }
                  iconPosition="start"
                />
              );
            })}
          </Tabs>

          {loading ? (
            <></>
          ) : (
            <>
              {langs?.map((item, index) => {
                return (
                  <TabPanel value={index.toString()} key={index}>
                    <TabContext value={value2}>
                      <Tabs
                        value={value2}
                        onChange={handleChange2}
                        textColor="secondary"
                        indicatorColor="secondary"
                        aria-label="secondary tabs">
                        <Tab sx={tabStyle} value="one" label="Contact Us" />
                        <Tab sx={tabStyle} value="two" label="FAQs" />
                      </Tabs>

                      <TabPanel value={"one"}>
                        <SuccessAlert show={success} setShow={(v) => setSuccess(v)} />
                        <ErrorAlert
                          show={fail}
                          setShow={(v) => setFail(v)}
                          message={"No changes were made to the current links"}
                        />
                        <div className="socialInputC">
                          <EmailIcon
                            sx={{ mr: 1 }}
                            style={{ fontSize: 29, color: COLORS.primary }}
                          />
                          <TextField
                            sx={{ width: 350 }}
                            label="Email"
                            variant="outlined"
                            size="small"
                            value={data[index]?.email || ""}
                            error={errors[index]?.error}
                            onChange={(e) => {
                              setData([
                                ...data.map((item, idx) => {
                                  if (idx === index) {
                                    return { ...item, email: e.target.value };
                                  } else {
                                    return item;
                                  }
                                }),
                              ]);
                              setErrors([
                                ...errors.map((item, idx) => {
                                  if (idx === index) {
                                    return { ...item, error: false };
                                  } else {
                                    return item;
                                  }
                                }),
                              ]);
                            }}
                          />
                        </div>
                        <div className="socialInputC">
                          <PhoneInTalkIcon
                            sx={{ mr: 1 }}
                            style={{ fontSize: 30, color: COLORS.primary }}
                          />
                          <TextField
                            sx={{ width: 350 }}
                            label="Phone"
                            variant="outlined"
                            size="small"
                            value={data[index]?.phone || ""}
                            error={errors[index]?.error}
                            onChange={(e) => {
                              setData([
                                ...data.map((item, idx) => {
                                  if (idx === index) {
                                    return { ...item, phone: e.target.value };
                                  } else {
                                    return item;
                                  }
                                }),
                              ]);
                              setErrors([
                                ...errors.map((item, idx) => {
                                  if (idx === index) {
                                    return { ...item, error: false };
                                  } else {
                                    return item;
                                  }
                                }),
                              ]);
                            }}
                          />
                        </div>
                        <div className="socialInputC">
                          <LocationOnIcon
                            sx={{ mr: 1 }}
                            style={{ fontSize: 30, color: COLORS.primary }}
                          />
                          <TextField
                            sx={{ width: 350 }}
                            label="Address"
                            variant="outlined"
                            size="small"
                            value={data[index]?.address || ""}
                            error={errors[index]?.error}
                            onChange={(e) => {
                              setData([
                                ...data.map((item, idx) => {
                                  if (idx === index) {
                                    return { ...item, address: e.target.value };
                                  } else {
                                    return item;
                                  }
                                }),
                              ]);
                              setErrors([
                                ...errors.map((item, idx) => {
                                  if (idx === index) {
                                    return { ...item, error: false };
                                  } else {
                                    return item;
                                  }
                                }),
                              ]);
                            }}
                          />
                        </div>

                        {user.perms[22].edit && (
                          <div className="submitBTN" onClick={() => submitData(item, index)}>
                            Save Changes
                          </div>
                        )}
                      </TabPanel>

                      <TabPanel value="two">
                        {data[index]?.faqs?.length > 0 && (
                          <>
                            <SuccessAlert show={success2} setShow={(v) => setSuccess2(v)} />
                            <ErrorAlert
                              show={fail2}
                              setShow={(v) => setFail2(v)}
                              message={"No changes were made to the current items"}
                            />
                          </>
                        )}
                        <div
                          style={{
                            width: "80%",
                          }}>
                          {data[index]?.faqs &&
                            data[index].faqs.map((item, indexx) => {
                              return (
                                <div
                                  key={indexx}
                                  style={{
                                    display: "flex",
                                    position: "relative",
                                    alignItems: "center",
                                    justifyContent: "flex-start",
                                    gap: 10,
                                  }}>
                                  <Accordion
                                    sx={{
                                      border: "solid",
                                      borderColor: "#fafafa",
                                      borderWidth: "1.5px",
                                      width: "94%",
                                      margin: 0.1,
                                    }}>
                                    <AccordionSummary
                                      expandIcon={<ExpandMoreIcon />}
                                      aria-controls="panel1-content"
                                      id="panel1-header">
                                      {item.q}
                                    </AccordionSummary>
                                    <AccordionDetails sx={{ backgroundColor: "#fafafa" }}>
                                      {item.a}
                                    </AccordionDetails>
                                  </Accordion>
                                  <div
                                    onClick={() => {
                                      setEditItem({ index: index, indexx: indexx });
                                    }}
                                    style={{ cursor: "pointer" }}>
                                    <IconButton
                                      sx={{
                                        color: "#888",
                                        "&:hover": {
                                          color: "var(--link)",
                                        },
                                        transition: "0.3s",
                                      }}>
                                      <EditIcon />
                                    </IconButton>
                                  </div>
                                  <div
                                    onClick={() => deleteItem(index, indexx)}
                                    style={{ cursor: "pointer" }}>
                                    <IconButton
                                      sx={{
                                        color: "#888",
                                        "&:hover": {
                                          color: "red",
                                        },
                                        transition: "0.3s",
                                      }}>
                                      <GridDeleteIcon />
                                    </IconButton>
                                  </div>
                                </div>
                              );
                            })}
                        </div>

                        <div
                          className="addC"
                          style={{
                            minHeight: openAdd[index]?.open ? 380 : 45,
                            padding: openAdd[index]?.open ? 20 : 0,
                            width: "80%",
                            marginTop: 10,
                          }}>
                          {openAdd[index]?.open && (
                            <div
                              className="addContent"
                              style={{
                                marginTop: 10,
                                marginBottom: 20,
                                display: "flex",
                                flexDirection: "column",
                                width: "100%",
                                alignItems: "center",
                                justifyContent: "center",
                              }}>
                              <TextField
                                label="Question"
                                sx={{ width: "90%" }}
                                size="small"
                                value={faq[index]?.q}
                                onChange={(e) =>
                                  setFaq([
                                    ...faq.map((item, idx) => {
                                      if (idx === index) {
                                        return { ...item, q: e.target.value };
                                      } else {
                                        return item;
                                      }
                                    }),
                                  ])
                                }
                              />
                              <TextField
                                label="Answer"
                                sx={{ width: "90%", mt: 2, mb: 2 }}
                                size="small"
                                multiline
                                rows={4}
                                value={faq[index]?.a}
                                onChange={(e) =>
                                  setFaq([
                                    ...faq.map((item, idx) => {
                                      if (idx === index) {
                                        return { ...item, a: e.target.value };
                                      } else {
                                        return item;
                                      }
                                    }),
                                  ])
                                }
                              />
                            </div>
                          )}
                          <div
                            className="addBTN"
                            onClick={() =>
                              openAdd[index]?.open
                                ? uploadFAQ(index)
                                : setOpenAdd([
                                  ...openAdd.map((item, idx) => {
                                    if (idx === index) {
                                      return { ...item, open: true };
                                    } else {
                                      return item;
                                    }
                                  }),
                                ])
                            }
                            style={{
                              width: openAdd[index]?.open ? "70%" : "100%",
                              height: 45,
                            }}>
                            Add New
                            <AddCircleOutlineRounded style={{ marginLeft: 7 }} />
                          </div>

                          {openAdd[index]?.open && (
                            <div
                              onClick={() => {
                                setOpenAdd([
                                  ...openAdd.map((item, idx) => {
                                    if (idx === index) {
                                      return { ...item, open: false };
                                    } else {
                                      return item;
                                    }
                                  }),
                                ]);
                                setFaq([
                                  ...faq.map((item, idx) => {
                                    if (idx === index) {
                                      return { ...item, a: "", q: "" };
                                    } else {
                                      return item;
                                    }
                                  }),
                                ]);
                              }}
                              className="cancelBTN">
                              Cancel
                            </div>
                          )}
                        </div>
                      </TabPanel>
                    </TabContext>
                  </TabPanel>
                );
              })}
            </>
          )}
        </Box>
      </TabContext>

      <EditFAQ
        itemToEdit={editItem}
        setItemToEdit={setEditItem}
        data={data}
        setData={setData}
        refresh={refresh}
        setRefresh={setRefresh}
        endpoint={"contact-us"}
        attribute={"contactData"}
      />
    </>
  );
}
